import React, { useMemo } from "react"
import { FaChevronRight } from "react-icons/fa"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import { EventStatusType } from "@letshang/constants"
import { get, isObject, orderBy, take } from "lodash-es"

const priorityOrder = [
  EventStatusType.ATTENDING,
  EventStatusType.ACCEPTED,
  "intrested",
  "viewed",
  EventStatusType.INVITED,
  EventStatusType.INITIATOR,
  EventStatusType.CO_HOST,
]

const statusIconMap = {
  [EventStatusType.INITIATOR]: "🎉",
  [EventStatusType.CO_HOST]: "🎉",

  [EventStatusType.ACCEPTED]: "👍", // Per Figma, or use ✅
  [EventStatusType.ATTENDING]: "👍",
  [EventStatusType.UNDER_REVIEW]: "🕒",
  [EventStatusType.CHECKED_IN]: "✅",

  INTERESTED: "👍",
  VIEWED: "👀",

  [EventStatusType.INVITED]: "📩",
}

const EventsBuddiesAvatar = ({ mutualBuddies = [] }) => {
  const statusesToDisplay = useMemo(() => {
    const sorted = orderBy(
      mutualBuddies,
      [
        (buddy) => {
          const index = priorityOrder.indexOf(get(buddy, "status", "UNKNOWN"))
          return index === -1 ? Infinity : index
        },
      ],
      ["asc"],
    )
    return take(sorted, 3)
  }, [mutualBuddies])

  if (!statusesToDisplay.length) return null

  return (
    // <div className="absolute top-2 right-2 flex items-center gap-2 bg-black bg-opacity-50 backdrop-blur-md p-2 rounded-md h-9">
    <BlurWrapper
      overlayOpacityDefault="5"
      overlayColorDefault="dark"
      className="flex p-2 h-9 absolute top-3 right-3 items-center rounded-lg gap-2"
    >
      {statusesToDisplay.map((item, index) => {
        const status = get(item, "status")
        const imageURL = isObject(item) ? get(item, "avatarUrl", "") : item
        return (
          <div
            key={index}
            className="relative h-6 w-6 rounded-full border border-white"
          >
            {statusIconMap[status] && (
              <span className="absolute -top-1 -right-1 text-sm">
                {statusIconMap[status]}
              </span>
            )}
            <img
              src={imageURL}
              alt="avatar"
              className="h-full w-full rounded-full object-cover"
            />
          </div>
        )
      })}
      <FaChevronRight className="text-white" size={16} />
      {/* </div>
       */}
    </BlurWrapper>
  )
}

export default EventsBuddiesAvatar
